import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormLabel from '@material-ui/core/FormLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import Select from '@material-ui/core/Select'
import AddIcon from '@material-ui/icons/Add'
import FilterListIcon from '@material-ui/icons/FilterList'
import React, { ChangeEvent, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ButtonToolbar from '../../components/ButtonToolbar'
import { StoreState } from '../../store'
import { getPeople, setFilters } from '../../store/people/peopleActions'
import { PeopleActionTypes } from '../../store/people/peopleTypes'
import { useMediaQuery } from '@material-ui/core'
import PrintIcon from '@material-ui/icons/Print'
import { Resume } from './Resume'

type PropsEvent = ChangeEvent<{ value: unknown }>

const statusPeople = ['Ativo', 'Inativo', 'Pendente', 'Desligado']

export default function PeopleToolbar() {
  const dispatch = useDispatch()
  const matches = useMediaQuery('(min-width: 600px)')

  const [isOpenModalFilter, setOpenModalFilter] = useState(false)
  const [showDetailsInPrint, setShowDetailsInPrint] = useState(false)
  const [isOpenModalPrint, setOpenModalPrint] = useState(false)

  const churchId = useSelector(({ sessionState }: StoreState) => {
    return sessionState.user?.churches[sessionState.selectedChurchIndex]?.id
  })

  const { filters } = useSelector(({ peopleState }: StoreState) => ({
    filters: peopleState.filters,
  }))
  const [state, setState] = useState({
    status: filters.status,
    gender: filters.gender,
    under_age: filters.under_age,
  })

  useEffect(() => {
    setState(filters)
  }, [filters, isOpenModalFilter])

  const onChangeFilterState = (key: string) => (event: PropsEvent) => {
    let content = event.target.value
    setState({ ...state, [key]: content })
  }

  const onClickApply = () => {
    state.under_age = showDetailsInPrint
    dispatch(setFilters(state.status, state.gender, state.under_age))
    dispatch({ type: PeopleActionTypes.EDITING_START })
    dispatch(getPeople())
    state.under_age = false

    setOpenModalFilter(false)
  }

  const onChangePrintState = (key: string) => (event: PropsEvent) => {
    setPrintState({ ...printState, [key]: event.target.value })
  }

  const [printState, setPrintState] = useState({
    status: filters.status,
    gender: filters.gender,
  })

  return (
    <>
      <ButtonToolbar
        text="Novo cadastro"
        matches={matches}
        IconLeft={AddIcon}
        onClick={() => dispatch({ type: PeopleActionTypes.EDITING_START })}
      />

      <ButtonToolbar
        text="Filtrar"
        matches={matches}
        IconLeft={FilterListIcon}
        onClick={() => setOpenModalFilter(true)}
      />

      <Button
        variant="outlined"
        style={{
          width: matches ? 180 : '100%',
          marginRight: matches ? 12 : 0,
          textTransform: 'none',
        }}
        onClick={() => {
          setOpenModalPrint(true)
        }}
      >
        <PrintIcon
          style={{
            marginRight: 4,
            color: '#555',
          }}
        />
        Relatório
      </Button>

      <Dialog
        onClose={() => setOpenModalFilter(false)}
        open={isOpenModalFilter}
      >
        <DialogTitle>Membros</DialogTitle>

        <DialogContent>
          <FormControl component="fieldset" style={{ marginTop: 12 }}>
            <FormLabel component="legend">Tipo</FormLabel>
            <RadioGroup
              row
              value={state.gender}
              onChange={onChangeFilterState('gender')}
            >
              <FormControlLabel
                value="all"
                control={<Radio color="primary" />}
                label="Todos"
              />
              <FormControlLabel
                value="Masculino"
                control={<Radio color="primary" />}
                label="Masculino"
              />
              <FormControlLabel
                value="Feminino"
                control={<Radio color="primary" />}
                label="Feminino"
              />
            </RadioGroup>
          </FormControl>

          <br />
          <FormControl component="fieldset" style={{ marginTop: 8 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showDetailsInPrint}
                  onChange={() => setShowDetailsInPrint((value) => !value)}
                />
              }
              label="Menores de 18 anos"
            />
          </FormControl>
          <br />

          <FormControl component="fieldset" style={{ marginTop: 8 }}>
            <FormLabel component="legend">Status</FormLabel>
            <Select
              value={state.status}
              displayEmpty
              onChange={onChangeFilterState('status')}
            >
              <MenuItem value="" disabled>
                <em>Status</em>
              </MenuItem>
              {statusPeople.map((status) => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
              <MenuItem value={'all'}>Todos</MenuItem>
            </Select>
            <FormHelperText>filtre por status dos membros</FormHelperText>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModalFilter(false)}>Cancelar</Button>
          <Button onClick={onClickApply} color="primary">
            Filtrar
          </Button>
        </DialogActions>
      </Dialog>

      <Resume
        matches={matches}
        churchId={churchId}
        setOpenModalPrint={setOpenModalPrint}
        isOpenModalPrint={isOpenModalPrint}
        setShowDetailsInPrint={setShowDetailsInPrint}
        onChangePrintState={onChangePrintState}
        printState={printState}
      />
    </>
  )
}
